import { ParticipantAvatar } from "@circle-react/components/LiveStreams/Room/ParticipantAvatar";
import { Typography } from "@circle-react-uikit/Typography";

interface ParticipantProps {
  record: {
    id: number;
    name: string;
    avatar_url: string;
    email: string;
  };
}
export const Participant = ({ record }: ParticipantProps) => (
  <div className="flex items-center">
    <div className="flex w-1/2 items-center py-2">
      <div className="relative mr-3 size-10">
        <ParticipantAvatar name={record.name} src={record.avatar_url} />
      </div>
      <Typography.LabelSm weight="semibold">{record.name}</Typography.LabelSm>
    </div>
    <div className="w-1/2">{record.email}</div>
  </div>
);
